




import { Vue, Component, Prop } from 'vue-property-decorator';

import DetailedSlotGeneric from './DetailedSlotGeneric.vue';

import { HighlightSlot } from '../types';

@Component({
    components: {
        DetailedSlotGeneric,
    },
})
export default class DetailedSlotHighlight extends Vue {
    @Prop() event!: HighlightSlot
}
